<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Fixed Deduction/Earning"
      text="Update Fixed Deduction/Earning"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localDoe.deduction_or_earning_id"
              label="Deduction/Earning"
              :value="localDoe.deduction_or_earning.name"
              :items="[localDoe.deduction_or_earning]"
              item-text="name"
              item-value="id"
              outlined
              filled
              disabled
            /> 
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localDoe.amount"
              label="Amount"
              prefix="RM"
              outlined
              class="disabled-background"
              disabled
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="startDateDisplay"
              label="Start date"
              disabled
              outlined
              class="disabled-background"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col
            cols="11"
            class="pb-0"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateDisplay"
                  label="End date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localDoe.end_date"
                no-title
                :min="localDoe.start_date"
                @input="endDateMenu = false"
              />
            </v-menu>
          </v-col>
          
          <v-col
            cols="1"
            class="pb-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  class="mt-3 ml-n3"
                  v-on="on"    
                  @click="localDoe.end_date = null"
                >
                  <v-icon color="red">
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Clear end date</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      doe: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDoe: null,
        endDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localDoe.start_date ? this.$moment(this.localDoe.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
      endDateDisplay () {
        return this.localDoe.end_date ? this.$moment(this.localDoe.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localDoe = { ...this.doe }

        if (this.localDoe.amount) { this.localDoe.amount = (Math.round((this.localDoe.amount / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)   

            this.$api.companyEmployeeDeductionOrEarnings().update(this.doe.id, this.prepareFormData())
              .then(res => {
                this.$emit('ended')
                this.$snack({ message: res.data.status })

                this.setProgressing(false)
                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          end_date: this.localDoe.end_date,
        }
      },
    },    
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}

.disabled-background >>> .v-input__slot{
  background: #f0f0f0
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
